import { CreditCardTypeId } from "../../enums/sitelink";
var CreditCardCsvSize = /* @__PURE__ */ ((CreditCardCsvSize2) => {
  CreditCardCsvSize2[CreditCardCsvSize2["Mastercard"] = 3] = "Mastercard";
  CreditCardCsvSize2[CreditCardCsvSize2["Visa"] = 3] = "Visa";
  CreditCardCsvSize2[CreditCardCsvSize2["AmericanExpress"] = 4] = "AmericanExpress";
  CreditCardCsvSize2[CreditCardCsvSize2["Discover"] = 3] = "Discover";
  CreditCardCsvSize2[CreditCardCsvSize2["Diners"] = 3] = "Diners";
  return CreditCardCsvSize2;
})(CreditCardCsvSize || {});
function creditCardType(cc) {
  const amex = new RegExp("^3[47][0-9]{13}$");
  const visa = new RegExp("^4[0-9]{12}(?:[0-9]{3})?$");
  const mastercard = new RegExp("^5[1-5][0-9]{14}$");
  const mastercard2 = new RegExp("^2[2-7][0-9]{14}$");
  const disco1 = new RegExp("^6011[0-9]{12}[0-9]*$");
  const disco2 = new RegExp("^62[24568][0-9]{13}[0-9]*$");
  const disco3 = new RegExp("^6[45][0-9]{14}[0-9]*$");
  const diners = new RegExp("^3[0689][0-9]{12}[0-9]*$");
  if (visa.test(cc)) {
    return CreditCardTypeId.Visa;
  }
  if (amex.test(cc)) {
    return CreditCardTypeId.AmericanExpress;
  }
  if (mastercard.test(cc) || mastercard2.test(cc)) {
    return CreditCardTypeId.Mastercard;
  }
  if (disco1.test(cc) || disco2.test(cc) || disco3.test(cc)) {
    return CreditCardTypeId.Discover;
  }
  if (diners.test(cc)) {
    return CreditCardTypeId.Diners;
  }
  return void 0;
}
function luhnCheck(number) {
  const sanitised = number.replace(/\D/g, "");
  if (sanitised.length === 0) return false;
  let sum = 0;
  let shouldDouble = false;
  for (let i = sanitised.length - 1; i >= 0; i--) {
    let digit = parseInt(sanitised[i], 10);
    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }
    sum += digit;
    shouldDouble = !shouldDouble;
  }
  return sum % 10 === 0;
}
function detectCardTypeFromPartial(partial) {
  const digits = partial.replace(/\D/g, "");
  if (digits.length === 0) return void 0;
  if (/^4/.test(digits)) return CreditCardTypeId.Visa;
  if (/^3[47]/.test(digits)) return CreditCardTypeId.AmericanExpress;
  if (/^(5[1-5]|2[2-7])/.test(digits)) return CreditCardTypeId.Mastercard;
  if (/^(6011|622|64|65)/.test(digits)) return CreditCardTypeId.Discover;
  if (/^3[0689]/.test(digits)) return CreditCardTypeId.Diners;
  return void 0;
}
function validateCreditCardNumber(number, location) {
  const allowedCreditCards = [];
  if (location.rapidstor.allowedCreditCardTypes.visa) {
    allowedCreditCards.push(CreditCardTypeId.Visa);
  }
  if (location.rapidstor.allowedCreditCardTypes.mastercard) {
    allowedCreditCards.push(CreditCardTypeId.Mastercard);
  }
  if (location.rapidstor.allowedCreditCardTypes.amex) {
    allowedCreditCards.push(CreditCardTypeId.AmericanExpress);
  }
  if (location.rapidstor.allowedCreditCardTypes.discover) {
    allowedCreditCards.push(CreditCardTypeId.Discover);
  }
  const ccType = creditCardType(number);
  if (!ccType) {
    return false;
  }
  if (!allowedCreditCards.includes(ccType)) {
    return false;
  }
  return true;
}
function validateCreditCardCSV(type, csv) {
  switch (type) {
    case CreditCardTypeId.Mastercard:
      return csv.length === 3 /* Mastercard */;
    case CreditCardTypeId.Visa:
      return csv.length === 3 /* Visa */;
    case CreditCardTypeId.AmericanExpress:
      return csv.length === 4 /* AmericanExpress */;
    case CreditCardTypeId.Discover:
      return csv.length === 3 /* Discover */;
    case CreditCardTypeId.Diners:
      return csv.length === 3 /* Diners */;
    default:
      return false;
  }
}
export {
  CreditCardCsvSize,
  CreditCardTypeId,
  creditCardType,
  detectCardTypeFromPartial,
  luhnCheck,
  validateCreditCardCSV,
  validateCreditCardNumber
};
//# sourceMappingURL=CreditCard.mjs.map